<template>
  <!-- 데스크톱 네비게이션 -->
  <div v-if="!isMobile">
    <div id="contents_wrap">
      <div class="contents" style="margin-bottom: -600px;">
        <div class="tab_container">
          <ul class="mypTabs" style="margin-top: 30px; margin-left:70px;">
            <li><router-link :class="{ 'on': currentPage === 'user' }" to="/info/user">내정보</router-link></li>
            <li><router-link :class="{ 'on': currentPage === 'bet' }" to="/info/bet">베팅내역</router-link></li>
            <li><router-link :class="{ 'on': currentPage === 'free_bet' }" to="/info/free_bet">프리베팅내역</router-link></li>
            <li><router-link :class="{ 'on': currentPage === 'betslip' }" to="/info/betslip">베팅슬립</router-link></li>
            <li><router-link :class="{ 'on': currentPage === 'customer' }" to="/bbs/c/l">1:1 문의</router-link></li>
            <li><router-link :class="{ 'on': currentPage === 'notes' }" to="/bbs/msg/l">쪽지함</router-link></li>
            <li><router-link :class="{ 'on': currentPage === 'recommender' }" to="/info/recommender">추천인</router-link></li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- 모바일 네비게이션 -->
  <div v-else class="menu_2_2">
    <div style="width:100%">
      <div :class="{ 'active': currentPage === 'user' }">
        <router-link to="/info/user">내정보</router-link>
      </div>
      <div :class="{ 'active': currentPage === 'bet' }">
        <router-link to="/info/bet">베팅내역</router-link>
      </div>
    </div>

    <div style="width:100%">
      <div :class="{ 'active': currentPage === 'free_bet' }">
        <router-link to="/info/free_bet">프리베팅내역</router-link>
      </div>
      <div :class="{ 'active': currentPage === 'betslip' }">
        <router-link to="/info/betslip">베팅슬립</router-link>
      </div>
    </div>

    <div style="width:100%">
      <div :class="{ 'active': currentPage === 'customer' }">
        <router-link to="/bbs/c/l">1:1문의</router-link>
      </div>
      <div :class="{ 'active': currentPage === 'notes' }">
        <router-link to="/bbs/msg/l">쪽지함</router-link>
      </div>
    </div>

    <div style="width:100%">
      <div :class="{ 'active': currentPage === 'recommender' }">
        <router-link to="/info/recommender">추천인</router-link>
      </div>
      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserNavigation',
  props: {
    currentPage: {
      type: String,
      required: true
    }
  },
  computed: {
    isMobile: function () {
      return this.$store.state.page.isMobile;
    }
  }
}
</script>

<style scoped>
/* 2칸 2줄 Grid Menu */
.menu_2_2 {
  width:100%;
  display: table;
  background-color: #1c2021;
}

.menu_2_2 DIV {
  display: table-row;
  border-left: #2D3232 solid 1px;
  border-top: #2D3232 solid 1px;
}

.menu_2_2 DIV DIV{
  width:33.33%;
  height: 40px;
  border-right: #2D3232 solid 1px;
  border-bottom: #2D3232 solid 1px;
  display: table-cell;
  text-align: center;
  vertical-align: middle;
}

.menu_2_2 DIV DIV a {
  color:#6B7A7A;
  font-weight: bold;
}

.menu_2_2 DIV DIV.active{
  background-color: #252929;
}

.menu_2_2 DIV DIV.active a {
  color:#a97bf5;
  font-weight: bold;
}

#contents_wrap {float:left; width:100%;}
.contents {width:1330px; margin:0px auto; min-height:600px; }

.tab_container {clear: both; float: left; width: 100%;}
</style>